import PriceConditionController from "./FieldConditions/PriceConditionController";
import PriceCalculator from "./PriceCalculator";

export default class ConditionPriceCalculator {

    fieldList = [];
    selectedFields = [];
    
    setAllFields(fieldsList) {
        this.fieldList = fieldsList
    }

    setSelectedFields(selectedFields) {
        this.selectedFields = selectedFields
    }

    getPriceFromSelectedOption(selectedOption) {
        
        if(selectedOption.price_conditions && selectedOption.price_conditions.length ){

            const condition = new PriceConditionController(selectedOption.price_conditions, this.selectedFields, this.fieldList);
            
            
            //console.log(selectedOption.label+ ' has price: ' + condition.getConditionPrice(selectedOption.type_price))

            return condition.getConditionPrice(selectedOption.type_price)
        }
        
        return selectedOption.type_price ?? 0;
    }
}